export const ICON_OBJECT_DATA = {
  'login-logo': '/assets/icon/login-logo.svg',
};
